import { connect } from 'react-redux'
import RetirementChart from './retirement-chart'

function mapStateToProps(state) {
  return {
    chartData: state.chartData,
    retirementAge: state.retirementAge,
    
    totalContributionsTaxable: state.totalContributionsTaxable,
    totalContributionsNonTaxable: state.totalContributionsNonTaxable,
    totalTaxable: state.totalTaxable,
    totalNonTaxable: state.totalNonTaxable,
  }
}

export default connect(mapStateToProps, {})(RetirementChart)

// export default function (component) {
//   return connect(mapStateToProps, mapDispatchToProps)(component)


// WEBPACK FOOTER //
// ./sections/retirement-chart/retirement-chart-container.js